import TApplicationInviteUserSmsVerifyPhoneNumberInput from './index.vue';

TApplicationInviteUserSmsVerifyPhoneNumberInput.install = app => {
  app.component(TApplicationInviteUserSmsVerifyPhoneNumberInput.name, TApplicationInviteUserSmsVerifyPhoneNumberInput);
};

export default TApplicationInviteUserSmsVerifyPhoneNumberInput;
